import { Content } from '@/features/gatewayManagement/pages/Content'
import { Empty } from '@/features/gatewayManagement/pages/Empty'
import { Header } from '@/features/gatewayManagement/pages/Header'
import { PinnedCard } from '@/features/gatewayManagement/pages/PinnedCard'
import { UserContext } from '@/features/gatewayManagement/utils/util'
import { Card, State } from '@seiue/ui'
import {
  QueryEnabledSchoolPluginsQuery,
  pluginApi,
} from 'packages/sdks-next/growp'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { DataBoard } from './DataBoard'
import { HotNewsCard } from './HotNewsCard'

/**
 * 用户首页内容
 *
 * @returns 组件
 */
export const UserContent: React.FC = () => {
  const [query, setQuery] = useState<QueryEnabledSchoolPluginsQuery>({})

  const { data: plugins, loading } = pluginApi.useQueryEnabledSchoolPlugins({
    ...query,
    tryExpand: [
      ['plugins', 'plugin'],
      ['plugins', 'tag'],
    ],
  })

  const { data: schoolPluginTags, loading: loadingTag } =
    pluginApi.useQuerySchoolPluginTags()

  const [pinnedPluginIds, setPinnedPluginIds] = useState<number[]>([])

  useEffect(() => {
    setPinnedPluginIds(plugins?.pinnedPluginIds || [])
  }, [plugins])

  return (
    <UserContext.Provider
      value={{
        pinnedPluginIds,
        setPinnedPluginIds: setPinnedPluginIds,
      }}
    >
      <Box>
        <DataBoard />
        {pinnedPluginIds.length ? (
          <PinnedCard
            schoolPlugins={
              plugins?.plugins?.filter((e) => pinnedPluginIds.includes(e.id)) ||
              []
            }
          />
        ) : null}

        <Card
          title={
            <Header
              title={'全部应用'}
              query={query}
              setQuery={setQuery}
              hiddenOpenCheck={true}
              hiddenRightButton={true}
            />
          }
          style={{
            width: '100%',
            minWidth: 992,
            maxWidth: 1600,
            minHeight: 'fit-content',
          }}
        >
          {loading || loadingTag ? (
            <State.Loading />
          ) : !plugins?.plugins?.length ? (
            <Empty query={query} />
          ) : (
            <Content
              schoolPlugins={plugins?.plugins || []}
              schoolPluginTags={schoolPluginTags || []}
              isForground={true}
              // 筛选了名称时，不显示资讯卡片
              extraCard={!!query.labelLike ? null : <HotNewsCard />}
            />
          )}
        </Card>
      </Box>
    </UserContext.Provider>
  )
}

const Box = styled.div`
  display: flex;
  align-items: center;
  min-height: 100%;
  padding: 20px;
  gap: 16px;
  flex-direction: column;
  min-width: 1032px;
  width: 100%;
  box-sizing: border-box;
`
